var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.list.length)?_c('div',{staticClass:"alerts bad-bg"},[_c('ul',_vm._l((_vm.list),function(error){return _c('li',{key:(_vm.key + "-" + error)},[_c('span',{staticClass:"fa fa-exclamation-triangle"}),_vm._v(_vm._s(error))])}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }